import { Fragment, useEffect } from "react";
import Select from "../../../../../styles/components/Select";

interface PaginationProps {
  defaultActivePage: number;
  pageSize: number;
  totalData: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

const PaginationComponent: React.FC<PaginationProps> = ({
  defaultActivePage,
  pageSize,
  totalData,
  onPageChange,
  onPageSizeChange,
}) => {
  const pageSizeOptions = [10, 20, 50, 100].map((pageSize) => ({
    label: pageSize.toString(),
    value: pageSize,
  }));
  const totalPages = Math.ceil(totalData / pageSize);
  const pages = [...Array(totalPages).keys()].map((_, i) => i + 1);
  const moveToPage = (page: number) => () => onPageChange(page);
  const setPageSize = (pageSize: number) => onPageSizeChange(pageSize);

  return (
    <div
      className="p-5 d-flex justify-content-between"
    >
      <div
        className="dataTables_length flex-left"
        id="kt_customers_table_length"
        data-testid="pagination"
      >
        <label>
          <select
            name="kt_customers_table_length"
            className="form-select form-select-sm form-select-solid"
            defaultValue={pageSize}
            onChange={(e) => {
              const selectedValue = e.target.value;
              setPageSize(Number(selectedValue));
            }}
          >
            {pageSizeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      </div>
      <ul className="pagination ml-auto">
        <li className={`page-item ${defaultActivePage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            aria-label="Previous"
            disabled={defaultActivePage === 1}
            onClick={moveToPage(Math.max(1, defaultActivePage - 1))}
          >
            <span aria-hidden="true">&laquo;</span>
          </button>
        </li>
        {defaultActivePage - 3 > 0 && pages.length > 5 && (
          <li className={`page-item`}>
            <button className="page-link">...</button>
          </li>
        )}

        {pages.map((page) => {
          // Simplified logic: show all pages if total pages <= 7, otherwise show range around current page
          const shouldShowPage = totalPages <= 7 || (
            page >= Math.max(1, defaultActivePage - 2) &&
            page <= Math.min(totalPages, defaultActivePage + 2)
          );
          
          if (!shouldShowPage) return null;
          
          return (
            <li
              key={page}
              className={`page-item ${
                page === defaultActivePage ? "active" : ""
              }`}
            >
              <button className="page-link" onClick={moveToPage(page)}>
                {page}
              </button>
            </li>
          );
        })}
        {defaultActivePage + 3 <= pages.length && pages.length > 5 && (
          <li className={`page-item`}>
            <button className="page-link">...</button>
          </li>
        )}
        <li className={`page-item ${defaultActivePage === totalPages ? "disabled" : ""}`}>
          <button
            className="page-link"
            aria-label="Next"
            disabled={defaultActivePage === totalPages}
            onClick={moveToPage(Math.min(totalPages, defaultActivePage + 1))}
          >
            <span aria-hidden="true">&raquo;</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default PaginationComponent;
